<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-0">
          <a-row class='py-2'>
            <a-col :sm='24' :lg='16' class='pr-1'>
              <a-input style="width: 100%" placeholder="Buscar..." v-model:value="searchText"
                @keyup.enter="getBusinessSetting(10, 0, searchText)" />
            </a-col>
            <a-col :sm='12' :lg='4' class='pl-1'>
              <button style="width: 100%" class="btn bg-holcim-bright-green text-white"
                @click="getBusinessSetting(10, 0, searchText)">
                <i class="fe fe-refresh-cw" />
                Buscar
              </button>
            </a-col>
            <a-col :sm='12' :lg='4' class='pl-1'>
              <router-link to="/catalogos/principal" style="width: 100%" class="btn bg-holcim-bright-blue">
                <i class="fe fe-arrow-left" />
              </router-link>
            </a-col>
          </a-row>
        </div>

        <a-modal :closable="false" :visible="visible" title="Registro de Razón Social">
          <a-form :model="form" ref="ruleForm" :rules="rules" @finish="submit" layout="vertical" label-align="left">
            <a-form-item required label="Nombre de Razón Social:" name="name">
              <a-input v-model:value="form.name" placeholder="Nombre de Razón Social" />
            </a-form-item>

            <a-form-item required label="Calle:" name="street">
              <a-input v-model:value="form.street" placeholder="Calle" />
            </a-form-item>

            <a-form-item required label="Edificio, torre o lugar:" name="place">
              <a-input v-model:value="form.place" placeholder="Edificio, torre o lugar" />
            </a-form-item>

            <a-form-item required label="Colonia:" name="district">
              <a-input v-model:value="form.district" placeholder="Colonia" />
            </a-form-item>

            <a-form-item required label="Delegación o municipio:" name="district">
              <a-input v-model:value="form.municipality" placeholder="Delegación o municipio" />
            </a-form-item>

            <a-form-item required label="Estado:" name="state">
              <a-select v-model:value="form.state">
                <a-select-option value="AGUASCALIENTES">
                  AGUASCALIENTES
                </a-select-option>
                <a-select-option value="BAJA CALIFORNIA">
                  BAJA CALIFORNIA
                </a-select-option>
                <a-select-option value="BAJA CALIFORNIA SUR">
                  BAJA CALIFORNIA SUR
                </a-select-option>
                <a-select-option value="CAMPECHE">
                  CAMPECHE
                </a-select-option>
                <a-select-option value="COAHUILA">
                  COAHUILA
                </a-select-option>
                <a-select-option value="COLIMA">
                  COLIMA
                </a-select-option>
                <a-select-option value="CHIAPAS">
                  CHIAPAS
                </a-select-option>
                <a-select-option value="CHIHUAHUA">
                  CHIHUAHUA
                </a-select-option>
                <a-select-option value="CIUDAD DE MÉXICO">
                  CIUDAD DE MÉXICO
                </a-select-option>
                <a-select-option value="DURANGO">
                  DURANGO
                </a-select-option>
                <a-select-option value="GUANAJUATO">
                  GUANAJUATO
                </a-select-option>
                <a-select-option value="GUERRERO">
                  GUERRERO
                </a-select-option>
                <a-select-option value="HIDALGO">
                  HIDALGO
                </a-select-option>
                <a-select-option value="JALISCO">
                  JALISCO
                </a-select-option>
                <a-select-option value="MÉXICO">
                  MÉXICO
                </a-select-option>
                <a-select-option value="MICHOACÁN">
                  MICHOACÁN
                </a-select-option>
                <a-select-option value="MORELOS">
                  MORELOS
                </a-select-option>
                <a-select-option value="NAYARIT">
                  NAYARIT
                </a-select-option>
                <a-select-option value="NUEVO LEÓN">
                  NUEVO LEÓN
                </a-select-option>
                <a-select-option value="OAXACA">
                  OAXACA
                </a-select-option>
                <a-select-option value="PUEBLA">
                  PUEBLA
                </a-select-option>
                <a-select-option value="QUERÉTARO">
                  QUERÉTARO
                </a-select-option>
                <a-select-option value="QUINTANA ROO">
                  QUINTANA ROO
                </a-select-option>
                <a-select-option value="SAN LUIS POTOSÍ">
                  SAN LUIS POTOSÍ
                </a-select-option>
                <a-select-option value="SINALOA">
                  SINALOA
                </a-select-option>
                <a-select-option value="SONORA">
                  SONORA
                </a-select-option>
                <a-select-option value="TABASCO">
                  TABASCO
                </a-select-option>
                <a-select-option value="TAMAULIPAS">
                  TAMAULIPAS
                </a-select-option>
                <a-select-option value="TLAXCALA">
                  TLAXCALA
                </a-select-option>
                <a-select-option value="VERACRUZ">
                  VERACRUZ
                </a-select-option>
                <a-select-option value="YUCATÁN">
                  YUCATÁN
                </a-select-option>
                <a-select-option value="ZACATECAS">
                  ZACATECAS
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item required label="Código Postal:" name="zipCode">
              <a-input v-model:value="form.zipCode" placeholder="Código Postal" />
            </a-form-item>

            <a-form-item required label="RFC:" name="rfc">
              <a-input v-model:value="form.rfc" placeholder="RFC" />
            </a-form-item>

            <a-form-item required label="Registro Canacintra:" name="canacintraRegistration">
              <a-input v-model:value="form.canacintraRegistration" placeholder="Registro Canacintra" />
            </a-form-item>

            <a-form-item required label="CMIC:" name="cmic">
              <a-input v-model:value="form.cmic" placeholder="CMIC" />
            </a-form-item>

            <error-manager-component v-if="errorHandler.errorDescription.errors.length > 0"
              :errors="errorHandler.errorDescription.errors" />

            <a-row class='py-1'>
              <a-col span="8" offset="10" v-if="formLoad">
                <a-spin tip="Cargando..." />
              </a-col>
              <a-col span="12" class="pt-1 pl-1" offset="6" v-else>
                <button type="submit" style="width: 100%" class="btn bg-holcim-bright-green text-white">
                  <i class="fe fe-save" />
                  Guardar
                </button>
              </a-col>
            </a-row>
          </a-form>

          <template #footer>
            <a-button key="back" @click="closeModal">
              <i class='fe fe-x-circle pr-2' />
              Cerrar
            </a-button>
          </template>
        </a-modal>

        <div class="card-body">
          <business-setting-table :data="businessSettings" :loading="tableLoading" @openModal="eventOpenModal"
            @softDelete="eventSoftDelete" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BusinessSettingTable from './components/BusinessSettingTable'
import useBusinessSetting from '../../../composables/useBusinessSetting'
import ErrorManagerComponent from '../../../components/errorManagerComponent'

export default {
  name: 'BusinessSettingIndex',
  components: { ErrorManagerComponent, BusinessSettingTable },
  setup() {
    const {
      searchText,
      visible,
      formId,
      form,
      formLoad,
      rules,
      businessSettings,
      tableLoading,
      errorHandler,
      ruleForm,

      openModal,
      closeModal,
      getBusinessSettings,
      submit,
      deleteRecord,

      eventOpenModal,
      eventSoftDelete,
    } = useBusinessSetting()

    return {
      searchText,
      visible,
      formId,
      form,
      formLoad,
      rules,
      businessSettings,
      tableLoading,
      errorHandler,
      ruleForm,

      openModal,
      closeModal,
      getBusinessSettings,
      submit,
      deleteRecord,

      eventOpenModal,
      eventSoftDelete,
    }
  },
}
</script>

<style scoped></style>
